// ============================================
// CALENDARIO DELL'AVVENTO - SISTEMA COMPLETO
// ============================================

(function() {
  'use strict';

  console.log('🎄 Script Calendario Avvento caricato!');

  // Configurazione sconti (solo percentuali per prezzi)
  const adventDiscounts = {
    1: 5, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 10, 8: 0, 9: 0, 10: 15,
    11: 0, 12: 0, 13: 15, 14: 0, 15: 20, 16: 0, 17: 15, 18: 0, 19: 0,
    20: 0, 21: 0, 22: 0, 23: 23, 24: 0
  };

  // Configurazione sconti limitati a collezioni specifiche
  const collectionOnlyDiscounts = {
    7: 'natale-2025',   // Giorno 7: 10% solo sulla collezione natale
    10: 'eco-fur',      // Giorno 10: 15% solo sulle eco-fur
    13: 'natale-2025',  // Giorno 13: 15% solo sulla collezione natale
    15: 'natale-2025',  // Giorno 15: 20% solo sulla collezione natale
    17: 'cerimonie'     // Giorno 17: 15% solo sulla collezione cerimonie
  };

  // Configurazione prodotti in omaggio - INSERISCI I VARIANT ID DEI TUOI PRODOTTI
  const adventGiftProducts = {
    2: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Anello' },
    3: { variantId: '56072147894652', productName: 'Porta Accessori' },
    6: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Calza Natalizia' },
    8: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Bracciale' },
    9: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Fermagli con Perle' },
    12: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Dolcevita' },
    14: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Specchietto Beauty' },
    16: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Accessorio a Sorpresa' },
    20: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Calze in Pizzo' },
    24: { variantId: 'INSERISCI_VARIANT_ID', productName: 'Pochette' }
  };

  // Messaggi popup per ogni giorno
  const adventGifts = {
    1: { icon: '🎁', title: 'Scarta il tuo regalo!', message: '5% di sconto su tutto + spedizione gratis da 50€', description: 'Ogni acquisto di oggi riceve automaticamente questo fantastico sconto!' },
    2: { icon: '💍', title: 'Anello in omaggio!', message: 'Un bellissimo anello ti aspetta', description: 'Con ogni ordine effettuato oggi riceverai un anello in omaggio!' },
    3: { icon: '👜', title: 'Porta accessori in regalo!', message: 'Organizza il tuo stile', description: 'Un elegante porta accessori in omaggio con ogni acquisto!' },
    4: { icon: '🚚', title: 'Spedizione gratis da 25€!', message: 'Oggi spedizione super conveniente', description: 'Solo per oggi, spedizione gratuita con ordini da 25€!' },
    5: { icon: '🎉', title: 'Il 3° capo al 20%!', message: 'Acquista 3 capi e risparmia', description: 'Il terzo capo lo paghi la metà - approfitta subito!' },
    6: { icon: '🧦', title: 'Calza natalizia in regalo!', message: 'Una morbida sorpresa', description: 'Ricevi una calza natalizia in omaggio con ogni ordine!' },
    7: { icon: '🎄', title: 'Weekend Special!', message: '10% sulla collezione Natale', description: 'Solo questo weekend - sconto speciale sulla collezione natalizia!' },
    8: { icon: '💎', title: 'Orecchini in omaggio!', message: 'Un bellissimo set di orecchini cuore in omaggio', description: 'Per ogni ordine riceverai una coppia di orecchini cuore inclusi.' },
    9: { icon: '✨', title: 'Fermagli con perle!', message: 'Eleganza nei dettagli', description: 'Fermagli con perle in omaggio con ogni ordine!' },
    10: { icon: '🐻', title: '15% sulle Eco Fur!', message: 'Prima edizione - solo oggi', description: 'Le nostre morbidissime eco-pellicce con uno sconto esclusivo!' },
    11: { icon: '📦', title: 'Mysterybox📦❓!', message: 'Acquista a sorpresa', description: 'Sblocca una sorpresa speciale!' },
    12: { icon: '👕', title: 'Dolcevita in regalo!', message: 'Comfort e stile', description: 'Un dolcevita basic in omaggio con ogni acquisto!' },
    13: { icon: '🎅', title: '15% collezione Natale!', message: 'Magia a metà mese', description: 'Sconto speciale su tutta la collezione natalizia!' },
    14: { icon: '💄', title: 'Specchietto Beauty!', message: 'Bellezza in ogni momento', description: 'Uno specchietto beauty in omaggio con ogni ordine!' },
    15: { icon: '🌟', title: '20% collezione Natale!', message: 'Super sconto di metà mese!', description: 'Il nostro sconto più alto sulla collezione Natale!' },
    16: { icon: '🎀', title: 'Accessorio a sorpresa!', message: 'Dalla nostra collezione', description: 'Un accessorio speciale scelto per te in regalo!' },
    17: { icon: '💃', title: '15% su Cerimonie!', message: 'Eleganza per le feste', description: 'Preparati alle feste con la collezione cerimonie in sconto!' },
    18: { icon: '🎄', title: 'Spedizione gratis!', message: 'Spedizione gratis con un minimo ordine di soli €20,00', description: 'Spedizione gratis su tutto con spesa minima di €29,00!' },
    19: { icon: '🛍️', title: '20% su ordini multipli!', message: 'Più compri, più risparmi', description: 'Acquista più capi insieme e ricevi il 20% di sconto!' },
    20: { icon: '🎁', title: 'Calze in pizzo!', message: 'Eleganza e raffinatezza', description: 'Calze in pizzo in omaggio con ogni ordine!' },
    21: { icon: '📦', title: 'Spedizione gratis con 2 capi!', message: 'Acquista almeno 2 prodotti', description: 'Con 2 o più capi la spedizione è completamente gratis!' },
    22: { icon: '💳', title: 'Gift Card Speciale!', message: '5€ Aggiuntivi GRATIS', description: 'Una gift card con valore maggiorato - solo oggi!' },
    23: { icon: '🎊', title: '23% su tutto!', message: 'Quasi Natale - super sconto!', description: 'Il 23 dicembre regaliamo il 23% di sconto su tutto il catalogo!' },
    24: { icon: '👛', title: 'Pochette in omaggio!', message: 'La vigilia è magica', description: 'Pochette elegante in regalo con ordine minimo di 15€!' }
  };

  // Data corrente
  const today = new Date();
  const currentDay = today.getDate();
  const currentMonth = today.getMonth() + 1;

  console.log(`📅 Data corrente: ${currentDay} ${currentMonth === 1 ? 'Gennaio' : currentMonth === 2 ? 'Febbraio' : currentMonth === 3 ? 'Marzo' : currentMonth === 4 ? 'Aprile' : currentMonth === 5 ? 'Maggio' : currentMonth === 6 ? 'Giugno' : currentMonth === 7 ? 'Luglio' : currentMonth === 8 ? 'Agosto' : currentMonth === 9 ? 'Settembre' : currentMonth === 10 ? 'Ottobre' : currentMonth === 11 ? 'Novembre' : 'Dicembre'} (${currentDay}/${currentMonth})`);

  // Verifica se siamo a dicembre (1-24)
  const isAdventSeason = currentMonth === 12 && currentDay >= 1 && currentDay <= 24;

  console.log(`🎅 Siamo nel periodo dell'Avvento? ${isAdventSeason ? 'SÌ' : 'NO'}`);

  if (!isAdventSeason) {
    console.log('⚠️ Script terminato: non siamo nel periodo dell\'Avvento (1-24 dicembre)');
    return;
  }

  const discountPercent = adventDiscounts[currentDay];
  const giftData = adventGifts[currentDay];

  // Badge personalizzati per offerte speciali (non sconti diretti)
  const customBadges = {
    5: 'Prendi 3 paga 1 al -20%',
    19: 'Prendi 3 paga 1 al -20%'  // Anche giorno 19 ha offerta multipla
  };

  // ============================================
  // FUNZIONE: Verifica se il prodotto appartiene alla collezione richiesta
  // ============================================
  function isProductInCollection(product, collectionHandle) {
    // Se non c'è una collezione richiesta, accetta tutti i prodotti
    if (!collectionHandle) return true;

    // Verifica se siamo nella pagina della collezione corretta
    const currentPath = window.location.pathname;
    if (currentPath.includes(`/collections/${collectionHandle}`)) {
      return true;
    }

    // Verifica se il prodotto è dentro una sezione specifica della collezione
    // Cerca il parent container che indica la collezione
    if (product) {
      // Controlla se il prodotto è in un container della collezione natale
      const christmasSection = product.closest('.christmas-collection-section, [class*="christmas"], [class*="natale"]');
      if (christmasSection && collectionHandle.includes('natale')) {
        return true;
      }

      // Controlla se il prodotto ha classi che indicano la collezione
      const productClasses = product.className || '';
      if (productClasses.includes('christmas') && collectionHandle.includes('natale')) {
        return true;
      }

      // Controlla se il link del prodotto contiene riferimenti alla collezione
      const productLink = product.querySelector('a[href*="/products/"]');
      if (productLink) {
        // Se il prodotto ha un attributo data che indica la collezione
        const dataCollection = product.getAttribute('data-collection') || productLink.getAttribute('data-collection');
        if (dataCollection && dataCollection.includes(collectionHandle)) {
          return true;
        }
      }
    }

    // Se siamo in pagina prodotto, verifica tramite meta tag o dati del prodotto
    if (currentPath.includes('/products/')) {
      // Cerca meta tag con le collezioni del prodotto
      const metaCollections = document.querySelector('meta[property="product:category"]');
      if (metaCollections) {
        const collections = metaCollections.content.toLowerCase();
        if (collections.includes(collectionHandle.toLowerCase())) {
          return true;
        }
      }

      // Ultimo tentativo: cerca link breadcrumb alla collezione
      const breadcrumbs = document.querySelectorAll('.breadcrumb a, [class*="breadcrumb"] a');
      for (let breadcrumb of breadcrumbs) {
        if (breadcrumb.href.includes(`/collections/${collectionHandle}`)) {
          return true;
        }
      }

      // Se siamo in pagina prodotto senza conferma della collezione, NON applicare lo sconto
      return false;
    }

    // Per altre pagine (homepage, ecc.), NON applicare sconti limitati a collezioni
    return false;
  }

  // ============================================
  // FUNZIONE: Identifica la sezione e restituisce la classe CSS
  // ============================================
  function getSectionClass(product, containerSelector) {
    // Controlla il container specifico
    if (containerSelector.includes('vacanze-card')) {
      return 'advent-tag--vacanze';
    }
    if (containerSelector.includes('carousel-item')) {
      return 'advent-tag--carousel';
    }
    if (containerSelector.includes('outfit-product-item')) {
      return 'advent-tag--outfit';
    }
    if (containerSelector.includes('product-card-christmas')) {
      return 'advent-tag--christmas';
    }
    if (containerSelector.includes('product-card')) {
      return 'advent-tag--product-card';
    }

    // Controlla il parent più vicino per identificare la sezione
    let parent = product.closest('.bestsellers-section, .christmas-header, section, [class*="section"]');

    if (parent) {
      const parentClass = parent.className;

      if (parentClass.includes('bestsellers-section')) {
        return 'advent-tag--carousel';
      }
      if (parentClass.includes('christmas-header')) {
        return 'advent-tag--header';
      }
      if (parentClass.includes('christmas') || parentClass.includes('natale')) {
        return 'advent-tag--christmas';
      }
      if (parentClass.includes('outfit')) {
        return 'advent-tag--outfit';
      }
      if (parentClass.includes('vacanze') || parentClass.includes('eco-fur')) {
        return 'advent-tag--vacanze';
      }
    }

    // Controlla se siamo in pagina prodotto
    if (product.closest('.t4s-product__media-wrapper, .product-single, .product-main')) {
      return 'advent-tag--product-page';
    }

    // Default: product card generico
    return 'advent-tag--product-card';
  }

  // ============================================
  // FUNZIONE: Applica decorazioni sui prodotti
  // ============================================
  function applyAdventDecorations() {
    // Solo se c'è uno sconto percentuale
    const hasDiscount = discountPercent && discountPercent > 0;
    // Verifica se lo sconto è limitato a una collezione specifica
    const requiredCollection = collectionOnlyDiscounts[currentDay];

    // Selettori per le sezioni
    const sectionSelectors = [
      { container: '.vacanze-card', price: '.vacanze-price' },
      { container: '.carousel-item', price: '.product-price' },
      { container: '.outfit-product-item', price: '.outfit-product-price' },
      { container: '.product-card-christmas', price: '.product-price' },
      { container: '.product-card', price: '.product-price' },
      { container: '.product-card', price: '.price' }
    ];

    // Selettori per pagina prodotto - più specifici (incluso tema t4s)
    const productPageSelectors = [
      // Tema t4s - SOLO info wrapper per il prezzo (non media wrapper per evitare bollini multipli)
      { container: '.t4s-product__info-wrapper', price: '.t4s-product-price' },
      { container: '.t4s-product__info-wrapper', price: '.t4s-product__price' },
      // Tema standard
      { container: '.product', price: '.price-item--regular' },
      { container: '.product', price: '.price__regular .price-item' },
      { container: '.product', price: '.price' },
      { container: '.product-single', price: '.price-item--regular' },
      { container: '.product-single', price: '.price__regular .price-item' },
      { container: '.product-single', price: '.price' },
      { container: '.product-main', price: '.price__regular' },
      { container: '.product-main', price: '.price-item--regular' },
      { container: '.product-main', price: '.price' },
      { container: '.product__info-wrapper', price: '.price__regular .price-item' },
      { container: '.product__info-wrapper', price: '.price-item--regular' },
      { container: '.product__info-wrapper', price: '.price' },
      { container: 'div[id*="shopify-section-product"]', price: '.price' },
      { container: 'div[id*="shopify-section-product"]', price: '.price-item--regular' }
    ];

    const allSelectors = [...sectionSelectors, ...productPageSelectors];

    // Flag per sapere se siamo in pagina prodotto
    let isProductPage = document.querySelector('.t4s-product__media-wrapper, .t4s-product__info-wrapper, [data-product-single-media-wrapper]') !== null;
    let productPageBadgeAdded = false; // Per aggiungere il bollino UNA SOLA VOLTA in pagina prodotto
    let productPageTagAdded = false; // Per aggiungere il tag UNA SOLA VOLTA in pagina prodotto

    // GESTIONE SPECIALE PER PAGINA PRODOTTO
    if (isProductPage) {
      // Aggiungi bollino sconto sulla prima immagine (se c'è sconto O badge personalizzato E appartiene alla collezione)
      const hasCustomBadge = customBadges[currentDay];
      const productContainer = document.querySelector('.t4s-product__info-wrapper, .product-single, .product-main');
      if ((hasDiscount || hasCustomBadge) && isProductInCollection(productContainer || document.body, requiredCollection)) {
        const firstMediaItem = document.querySelector('.t4s-product__media-item.is-selected, .t4s-product__media-item:first-child');
        if (firstMediaItem && !firstMediaItem.querySelector('.advent-discount-badge')) {
          const badge = document.createElement('div');
          badge.className = 'advent-discount-badge';
          badge.textContent = hasCustomBadge ? hasCustomBadge : `-${discountPercent}%`;
          firstMediaItem.style.position = 'relative';
          firstMediaItem.insertBefore(badge, firstMediaItem.firstChild);
          productPageBadgeAdded = true;
          console.log('✅ Bollino aggiunto sulla prima immagine della pagina prodotto');
        }
      }

      // Aggiungi tag calendario sulla prima immagine
      const firstMediaItem = document.querySelector('.t4s-product__media-item.is-selected, .t4s-product__media-item:first-child');
      if (firstMediaItem && !firstMediaItem.querySelector('.advent-tag')) {
        const adventTag = document.createElement('div');
        adventTag.className = 'advent-tag advent-tag--product-page';

        adventTag.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openGiftPopup();
        });

        const tagText = document.createElement('div');
        tagText.className = 'advent-tag-text';
        tagText.textContent = "Calendario dell'Avvento";

        adventTag.appendChild(tagText);

        firstMediaItem.style.position = 'relative';
        firstMediaItem.insertBefore(adventTag, firstMediaItem.firstChild);
        productPageTagAdded = true;
        console.log('✅ Tag calendario aggiunto sulla prima immagine della pagina prodotto');
      }
    }

    allSelectors.forEach(({ container, price }) => {
      const products = document.querySelectorAll(container);

      products.forEach(product => {
        if (product.classList.contains('advent-processed')) return;
        product.classList.add('advent-processed');

        console.log('Processing container:', container);

        // Assicura posizionamento relativo
        const computedStyle = window.getComputedStyle(product);
        if (computedStyle.position === 'static') {
          product.style.position = 'relative';
        }

        // Verifica se questo specifico container è di pagina prodotto
        const isThisProductPageContainer =
          container.includes('t4s-product__info-wrapper') ||
          container.includes('product-single') ||
          container.includes('product-main') ||
          container.includes('product__info-wrapper') ||
          container.includes('shopify-section-product');

        // SALTA i container di pagina prodotto (gestiti sopra)
        if (isProductPage && isThisProductPageContainer) {
          // Modifica solo i prezzi per la pagina prodotto
          if (hasDiscount && isProductInCollection(product, requiredCollection)) {
            const priceElements = product.querySelectorAll(price);
            priceElements.forEach(priceElement => {
              if (priceElement && !priceElement.classList.contains('price-processed')) {
                priceElement.classList.add('price-processed');
                const priceText = priceElement.textContent.trim();
                const priceMatch = priceText.match(/[\d.,]+/);
                if (priceMatch) {
                  const originalPrice = parseFloat(priceMatch[0].replace(',', '.'));
                  if (!isNaN(originalPrice) && originalPrice > 0) {
                    const discountedPrice = originalPrice * (1 - discountPercent / 100);
                    const currency = priceText.includes('€') ? '€' : '';
                    const currencyBefore = priceText.indexOf('€') < priceText.indexOf(priceMatch[0]);
                    const formatPrice = (price) => {
                      const formatted = price.toFixed(2).replace('.', ',');
                      return currencyBefore ? `${currency}${formatted}` : `${formatted}${currency}`;
                    };
                    const priceContainer = document.createElement('div');
                    priceContainer.className = 'price-container-advent';
                    const originalPriceSpan = document.createElement('span');
                    originalPriceSpan.className = 'original-price-advent';
                    originalPriceSpan.textContent = formatPrice(originalPrice);
                    const discountedPriceSpan = document.createElement('span');
                    discountedPriceSpan.className = 'discounted-price-advent';
                    discountedPriceSpan.textContent = formatPrice(discountedPrice);
                    priceContainer.appendChild(originalPriceSpan);
                    priceContainer.appendChild(discountedPriceSpan);
                    priceElement.innerHTML = '';
                    priceElement.appendChild(priceContainer);
                  }
                }
              }
            });
          }
          return; // Salta il resto (tag e bollino già gestiti)
        }

        // Aggiungi bollino sconto per altre pagine (homepage, collezioni)
        const hasCustomBadge = customBadges[currentDay];
        if ((hasDiscount || hasCustomBadge) && !isProductPage && isProductInCollection(product, requiredCollection)) {
          const badge = document.createElement('div');
          badge.className = 'advent-discount-badge';
          badge.textContent = hasCustomBadge ? hasCustomBadge : `-${discountPercent}%`;
          product.insertBefore(badge, product.firstChild);
        }

        // Aggiungi tag Calendario dell'Avvento per altre pagine (non pagina prodotto)
        if (!isProductPage && !isThisProductPageContainer) {
          const adventTag = document.createElement('div');
          adventTag.className = 'advent-tag';

          // Identifica la sezione e applica classe specifica
          const sectionClass = getSectionClass(product, container);
          if (sectionClass) {
            adventTag.classList.add(sectionClass);
          }

          adventTag.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openGiftPopup();
          });

          const tagText = document.createElement('div');
          tagText.className = 'advent-tag-text';
          tagText.textContent = "Calendario dell'Avvento";

          adventTag.appendChild(tagText);

          // Cerca il contenitore dell'immagine
          let imageContainer = product.querySelector(
            '.product-image, .carousel-image, .vacanze-image, .product-card-image, ' +
            '.product__media, .product__media-wrapper, .product-gallery, .product-thumb, ' +
            'a[href*="/products/"], .media, [class*="media"], [class*="image"]'
          );

          // Fallback: cerca qualsiasi elemento con tag img
          if (!imageContainer) {
            const imgElement = product.querySelector('img');
            if (imgElement) {
              imageContainer = imgElement.parentElement;
              console.log('Found image container via img parent:', imageContainer.className);
            }
          }

          if (imageContainer) {
            // Assicura posizionamento relativo per il contenitore immagine
            const imgStyle = window.getComputedStyle(imageContainer);
            if (imgStyle.position === 'static') {
              imageContainer.style.position = 'relative';
            }
            console.log('Appending tag to image container:', imageContainer.className);
            imageContainer.appendChild(adventTag);
          } else {
            // Fallback finale: inserisci nel prodotto
            console.log('No image container found, appending to product');
            product.insertBefore(adventTag, product.firstChild);
          }
        } // Fine blocco if (!isProductPage && !isThisProductPageContainer)

        // Modifica prezzi (solo se c'è sconto E il prodotto appartiene alla collezione richiesta)
        if (hasDiscount && isProductInCollection(product, requiredCollection)) {
          // Trova tutti i possibili elementi prezzo
          const priceElements = product.querySelectorAll(price);

          priceElements.forEach(priceElement => {
            if (priceElement && !priceElement.classList.contains('price-processed')) {
              priceElement.classList.add('price-processed');

              const priceText = priceElement.textContent.trim();
              const priceMatch = priceText.match(/[\d.,]+/);

              if (priceMatch) {
                const originalPrice = parseFloat(priceMatch[0].replace(',', '.'));

                if (!isNaN(originalPrice) && originalPrice > 0) {
                  const discountedPrice = originalPrice * (1 - discountPercent / 100);
                  const currency = priceText.includes('€') ? '€' : '';
                  const currencyBefore = priceText.indexOf('€') < priceText.indexOf(priceMatch[0]);

                  const formatPrice = (price) => {
                    const formatted = price.toFixed(2).replace('.', ',');
                    return currencyBefore ? `${currency}${formatted}` : `${formatted}${currency}`;
                  };

                  const priceContainer = document.createElement('div');
                  priceContainer.className = 'price-container-advent';

                  const originalPriceSpan = document.createElement('span');
                  originalPriceSpan.className = 'original-price-advent';
                  originalPriceSpan.textContent = formatPrice(originalPrice);

                  const discountedPriceSpan = document.createElement('span');
                  discountedPriceSpan.className = 'discounted-price-advent';
                  discountedPriceSpan.textContent = formatPrice(discountedPrice);

                  priceContainer.appendChild(originalPriceSpan);
                  priceContainer.appendChild(discountedPriceSpan);

                  priceElement.innerHTML = '';
                  priceElement.appendChild(priceContainer);
                }
              }
            }
          });
        }
      });
    });

    console.log(`✅ Calendario Avvento - Giorno ${currentDay} decorato`);
  }

  // ============================================
  // FUNZIONE: Aggiungi prodotto in omaggio al carrello
  // ============================================
  function addGiftToCart(variantId, productName) {
    // Mostra messaggio di caricamento
    const button = document.getElementById('riscatta-gift-btn');
    if (button) {
      button.disabled = true;
      button.innerHTML = '<span style="display:inline-block;animation:spin 1s linear infinite;">⏳</span> Aggiunta in corso...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_Omaggio': `Calendario Avvento - Giorno ${currentDay}`
          }
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      // Successo - mostra messaggio e reindirizza
      alert(`🎁 ${productName} aggiunto al carrello!`);
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Errore aggiunta al carrello:', error);
      alert('Si è verificato un errore. Riprova o contatta l\'assistenza.');
      if (button) {
        button.disabled = false;
        button.innerHTML = '🎁 RISCATTA OMAGGIO';
      }
    });
  }

  // ============================================
  // FUNZIONE: Crea e apre popup regalo
  // ============================================
  function createGiftPopup() {
    if (document.getElementById('advent-gift-popup')) return;

    // Verifica se c'è un prodotto in omaggio per oggi
    const giftProduct = adventGiftProducts[currentDay];
    const hasGiftProduct = giftProduct && giftProduct.variantId && !giftProduct.variantId.includes('INSERISCI');

    const overlay = document.createElement('div');
    overlay.id = 'advent-gift-popup';
    overlay.className = 'advent-gift-popup-overlay';

    // Crea il bottone Riscatta solo se c'è un prodotto valido
    const giftButtonHTML = hasGiftProduct ? `
      <button id="riscatta-gift-btn" class="gift-riscatta-button">
        🎁 RISCATTA OMAGGIO
      </button>
    ` : '';

    overlay.innerHTML = `
      <div class="advent-gift-popup">
        <div class="gift-popup-snow">❄</div>
        <div class="gift-popup-snow">❅</div>
        <div class="gift-popup-snow">❆</div>
        <div class="gift-popup-snow">❄</div>
        <div class="gift-popup-snow">❅</div>

        <div class="gift-popup-header">
          <button class="gift-popup-close">&times;</button>
          <div class="gift-popup-date">${currentDay} Dicembre</div>
          <h2 class="gift-popup-title">${giftData.title}</h2>
        </div>

        <div class="gift-popup-content">
          <div class="gift-icon-large">${giftData.icon}</div>
          <div class="gift-message">${giftData.message}</div>
          <div class="gift-description">${giftData.description}</div>
          ${giftButtonHTML}
          <button class="gift-cta-button" onclick="document.getElementById('advent-gift-popup').classList.remove('active')">
            🎄 Scopri i prodotti! 🎄
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    // Close handlers
    overlay.querySelector('.gift-popup-close').addEventListener('click', () => {
      overlay.classList.remove('active');
    });

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        overlay.classList.remove('active');
      }
    });

    // Aggiungi event listener per il bottone Riscatta se esiste
    if (hasGiftProduct) {
      const riscattaBtn = document.getElementById('riscatta-gift-btn');
      if (riscattaBtn) {
        riscattaBtn.addEventListener('click', () => {
          addGiftToCart(giftProduct.variantId, giftProduct.productName);
        });
      }
    }
  }

  function openGiftPopup() {
    const popup = document.getElementById('advent-gift-popup');
    if (popup) {
      popup.classList.add('active');
    }
  }

  // ============================================
  // INIZIALIZZAZIONE
  // ============================================
  function init() {
    createGiftPopup();
    applyAdventDecorations();
  }

  // Esegui quando DOM pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-applica per contenuti dinamici
  setTimeout(applyAdventDecorations, 1000);
  setTimeout(applyAdventDecorations, 3000);

  // Observer per nuovi contenuti
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            const hasProducts = node.classList && (
              node.classList.contains('product-card') ||
              node.classList.contains('carousel-item') ||
              node.classList.contains('vacanze-card') ||
              node.classList.contains('product-single') ||
              node.classList.contains('t4s-product__media-wrapper') ||
              node.classList.contains('t4s-product__info-wrapper') ||
              node.querySelector('.product-card, .carousel-item, .vacanze-card, .product-single, .t4s-product__media-wrapper, .t4s-product__info-wrapper')
            );
            if (hasProducts) shouldUpdate = true;
          }
        });
      }
    });
    if (shouldUpdate) setTimeout(applyAdventDecorations, 100);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // API pubblica
  window.AdventCalendar = {
    refresh: function() {
      document.querySelectorAll('.advent-processed, .price-processed').forEach(el => {
        el.classList.remove('advent-processed', 'price-processed');
      });
      document.querySelectorAll('.advent-discount-badge, .advent-tag').forEach(el => {
        el.remove();
      });
      applyAdventDecorations();
    },
    openGift: openGiftPopup
  };

})();
